import { LaminatedCardPaymentCreationDto } from '../dtos/laminated-card-payment.dto';
import { LaminatedCardPaymentCreation } from '../models/laminated-card-payment';
import { orderPaymentCardMapper } from './order-payment-card.mapper';

/**
 * Map data to dto.
 * @param {LaminatedCardPaymentCreation} data Data
 * @returns {LaminatedCardPaymentCreationDto}
 */
function toCreationDto(data) {
  return orderPaymentCardMapper.toCreationDto({
    paymentProfileId: data.paymentProfileId,
    card: data.card,
    groupAdminId: data.groupAdminId ?? null,
  });
}

export const laminatedCardPaymentMapper = {
  toCreationDto,
};
